/**
 * Created by WorkAxis www.workaxis.in
 * Services page — AI & product engineering partner.
 */
import React from 'react';
import "./style.css";
import {Link} from "react-router-dom";
import {
    serviceBuckets,
    howWeWork,
    howWeWorkNote,
    typicalEngagements,
    techStack,
    workFlow
} from "./data";
import {PageHero, CtaSection, SectionHead} from "./shared";
import {Magnetic, Reveal, Stagger, StaggerItem, TiltCard} from "./motion";

export default function Services() {
    return (
        <div>
            <PageHero
                kicker="Services"
                title={<>AI & product engineering, <span className="wx-grad-text">end to end.</span></>}
                lead="We partner with businesses that need production-ready software and AI — not a generic
                      development vendor. One team owns discovery, architecture, build, deploy, and scale."
            />

            {/* ---------- Service buckets ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-services-grid is-detailed is-four-buckets">
                        {serviceBuckets.map((s, i) => (
                            <TiltCard key={s.name} className="wx-service-card" delay={(i % 2) * 0.09}>
                                <div className="wx-service-index">{String(i + 1).padStart(2, '0')} /</div>
                                <div className="wx-service-title">{s.name}</div>
                                <div className="wx-service-desc">{s.tagline}</div>
                                <p className="wx-bucket-desc">{s.desc}</p>
                                <ul className="wx-product-points">
                                    {s.points.map((p) => <li key={p}>{p}</li>)}
                                </ul>
                                <div className="wx-chip-row">
                                    {s.examples.slice(0, 4).map((ex) => (
                                        <span className="wx-chip is-small" key={ex}>{ex}</span>
                                    ))}
                                </div>
                            </TiltCard>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- How we work ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <SectionHead kicker="How we work" title="From business problem to production." lead={howWeWorkNote}/>
                    <div className="wx-process is-four">
                        {howWeWork.map((item, i) => (
                            <Reveal key={item.step} className="wx-process-step" delay={i * 0.09}>
                                <div className="wx-process-num">{String(i + 1).padStart(2, '0')}</div>
                                <div className="wx-process-name">{item.step}</div>
                                <p className="wx-process-desc">{item.desc}</p>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal className="wx-section-link">
                        <Magnetic>
                            <Link to="/contact" className="wx-btn wx-btn-primary">Discuss your project</Link>
                        </Magnetic>
                    </Reveal>
                </div>
            </section>

            {/* ---------- Typical engagements ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <SectionHead kicker="Typical engagements" title="Flexible models — scoped after we understand your problem."/>
                    <div className="wx-services-grid is-three">
                        {typicalEngagements.map((e, i) => (
                            <TiltCard key={e.name} className="wx-service-card" delay={i * 0.09}>
                                <div className="wx-service-title">{e.name}</div>
                                <div className="wx-service-desc">{e.desc}</div>
                            </TiltCard>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Tech stack ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <SectionHead kicker="Technology" title="A proven, modern stack."/>
                    <Stagger className="wx-chips" gap={0.05}>
                        {techStack.map((t) => <StaggerItem as="span" className="wx-chip" key={t}>{t}</StaggerItem>)}
                    </Stagger>
                </div>
            </section>

            {/* ---------- Process ---------- */}
            <section className="wx-section" id="process">
                <div className="wx-container">
                    <SectionHead kicker="Delivery process" title="Transparent at every step." lead="Discovery-first delivery — from workflow mapping to operating in production."/>
                    <div className="wx-process">
                        {workFlow.map((step, i) => (
                            <Reveal key={step} className="wx-process-step" delay={(i % 4) * 0.09}>
                                <div className="wx-process-num">{String(i + 1).padStart(2, '0')}</div>
                                <div className="wx-process-name">{step}</div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <CtaSection
                title={<>Get a <span className="wx-grad-text">solution assessment</span></>}
                text="Tell us what you're trying to automate or build. We'll respond within one business day with next steps."
                primaryLabel="Discuss your project"
            />
        </div>
    );
}
